import { ArticleParagraph2, ArticleParagraph3 } from '@cian/ui-kit';

import { clsx } from 'clsx';
import { FC, PropsWithChildren } from 'react';

import { ICustomFormFieldProps } from './types';

import * as styles from './CustomFormField.css';

export const CustomFormField: FC<PropsWithChildren<ICustomFormFieldProps>> = props => {
  const {
    children,
    childrenContainerClassName,
    containerClassName,
    errorMessage,
    label,
    required = false,
    testId,
  } = props;

  return (
    <div className={clsx(styles['container'], containerClassName)} data-testid={testId}>
      <div className={clsx(styles['label-container'], { [styles['required']]: required })}>
        <ArticleParagraph2 as="span" color="black_100" fontWeight="normal">
          {label}
        </ArticleParagraph2>
      </div>
      <div className={childrenContainerClassName}>{children}</div>
      <div className={styles['error-message-container']} data-testid="error-message-container">
        <ArticleParagraph3 as="span" color="error_100" fontWeight="normal">
          {errorMessage}
        </ArticleParagraph3>
      </div>
    </div>
  );
};

CustomFormField.displayName = 'CustomFormField';
